import { styled } from '@mui/material/styles';

/** List row separated from the next one by a divider rule; the last row has none. */
export const DividedRow = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  '&:not(:last-child)': { borderBottom: `1px solid ${theme.palette.divider}` },
}));
